export const exitWrapper = {
  margin: '5px -5px 20px 0px',
}

export const exit = {
  float: 'right',
  transform: 'scale(1.2)',
  marginRight: '-8px',
  fontWeight: '100',
  color: 'rgb(72, 151, 248)',
  transition: '.3s',
  cursor: 'pointer',
}

export const exitHover = {
  transform: 'scale(1.3)',
}
